/*
 * @Author: zhangqf
 * @Date: 2018-11-26 14:57:40 
 * @Last Modified by: Scherger
 * @Last Modified time: 2019-09-17 12:26:50
 */

import {
  SERVER
} from "@/api/apiConfig.js";
 import sessionFun from "@/utils/cc-webapp/login.js";

import axios from 'axios';

var _appId = SERVER.APPID;
var _nativeData = "";

function setAppId(appId) {
  _appId = appId
}

//设置应用信息
function setNative(data) {
  _nativeData = data
  console.log(_nativeData);
}

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}


/**
 * 区块请求方法
 * @param  {object} url  请求链接
 * @param  {String} params 是否显示区块(默认)
 * @param  {String} returnName 直接返回清单数据
 */
function blockAxios(url, params, returnName) {
  return this.doAxios(url, params, 'GET').then(res => {
    return returnName ? res[returnName] : res
  })
}

// 并发请求方法（多个接口同步同步）
/** 
 * @example
 * this.GLOBAL_.ccRequest
        .allAxios(this.p1(), this.p2(), this.p2())
        .then(reload => {
          console.log("完成");
        });
 */
function allAxios() {
  return axios.all([].slice.call(arguments))
    .then(axios.spread(function (acct, perms) {
      // 两个请求现在都执行完成

      return {
        acct,
        perms
      }

    }));
}

/** 不带session請求方法
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 */
function doAxios(url, params, method, isHttps) {
  let m = method ? method : "POST" //默认使用POST

  console.log('method',method);
  return new Promise(function (resolve, reject) {

    console.log('reques.js')

    return apiAxios(m, url, params,false, isHttps).then(res => {
      resolve(res)
    }).catch(e => {
      reject(e)
    })

  })

}


/** 带session请求
 * @param  {string} url 请求url
 * @param  {data} params 请求携带参数
 * @param  {string} method  默认POST  可传入 GET / POST
 * @param  {Boolean } isLogin  是否需要跳转login  
 * @param  {string } isSession  外部传入session，   
 * @param  {string } isStorage  是否缓存， 默认不缓存    
 * @param  {Boolean } isAllUrl  開發調試
 * @Examples
 * isLogin 为检查session 当为空的时候是否需要跳转登录页判断，
 * 为兼容以调用过的请求， 所以默认为跳转登录页
 * 按照调用语义 ，调用的时候可传入 ‘no login’
 * doSessionAxios(url, params, method, 'no login')
 * @Examples
 * isSession 为外部传入，默认不传入自动获取本地session，
 * 当前用于新用户注册邮箱预传入，绑定成功才缓存到本地。
 * 
 */
 function doSessionAxios(url, params, method, isLogin, isSession, isStorage, isAllUrl) {
  // console.log('sessionAxios', url);

  let m = method ? method : "POST" //默认使用POST
  var loginFlag = false

  if (isLogin) {
    loginFlag = true
  }

  return new Promise(function (resolve, reject) {


    console.log('查看issession是否是true',isSession);

     
    //如果存在外部传入session就使用外部的
    if (isSession) {

      //console.log('查看issession是否是true',isSession);

      console.log('url:::',url);
      console.log('params:::',params);
      return apiAxios(m, url, params, isSession, isAllUrl).then(res => { 
        console.log('1apiAxios',apiAxios);
        if (isStorage) {

          setRequestData({
            url: url,
            id: params.id,
            resultData: res
          })
        }
        resolve(res)

      }).catch(e => {
        // console.log('session api catch', e);
        
        console.log('33跳到了没有session的catch里面',JSON.stringify(e));

        if (e.response.status == 500) {
        //  native.showToast(e.response.data.message);
        }

        if (e.response.data.code == 40101) {
          // alert('login2 request 40101')
          // native.removeStorage('app_session');
          // native.showToast("用戶已過期請退出重新登錄");
          sessionFun.go()

        } else if (e.response.data.code == 40102) {

        //  native.showToast("該用戶已被系統停用");

        } else {
          reject(e)
        }

      })

    } 
    else {

      console.log('跳到了这里来啦');

      return sessionFun.check(loginFlag).then(w_session => {

         console.log(w_session);



        //不跳登錄頁且沒有獲取到session時
        if (loginFlag && w_session.session == null) {
          let e = {
            isLogin: false
          }
          return reject(e)
        }

        // console.log("sessionFun", w_session);

        return apiAxios(m, url, params, w_session).then(res => {
          console.log('2apiAxios',apiAxios);
          if (isStorage) {
            setRequestData({
              url: url,
              id: params.id,
              resultData: res
            })
          }
          resolve(res)
          // console.log(res);

        }).catch(e => {
          // console.log('catch');

          console.log('11跳到了没有session的catch里面',e);


          if (e.response.status == 500) {
            //native.showToast(e.response.data.message);
          }

          if (e.response.data.code == 40101) {
            // alert('login2 request 40101 2')
            // native.removeStorage('app_session');
            // native.showToast("用戶已過期請退出重新登錄");
            sessionFun.go()

          } else if (e.response.data.code == 40102) {

            //native.showToast("該用戶已被系統停用");

          } else {
            reject(e)
          }
        })

      }).catch(err => {

        return apiAxios(m, url, params, false).then(res => {
          console.log('3apiAxios',apiAxios);
          if (isStorage) {

            setRequestData({
              url: url,
              id: params.id,
              resultData: res
            })
          }
          resolve(res)
          // console.log(res);

        }).catch(e => {

          console.log('22跳到了没有session的catch里面',JSON.stringify(e));

          if (e.response.status == 500) {
           // native.showToast(e.response.data.message);
          }

          if (e.response.data.code == 40101) {
            // alert('login2 request 40101 3')
            // native.removeStorage('app_session');
            // native.showToast("用戶已過期請退出重新登錄");
            sessionFun.go()

          } else if (e.response.data.code == 40102) {

           // native.showToast("該用戶已被系統停用");

          } else {
            reject(e)
          }
        })



      })

    }


  })

}  



// 底层请求方法
function apiAxios(method, url, params, app_session, isHttps) {

  return new Promise(function (resolve, reject) {
    var sendUrl = SERVER.URL + url

    if (isHttps) {
      sendUrl = url
    }

    

    console.log('是否会进这个底层的请求方法', app_session);

    //填入設備類型參數

    console.log("apiAxios app_session", _nativeData)

    //过滤空参数
    if (params) {
      params = filterNull(params)
    }

    //传入APPID 参数
    if (!params.appId) {
      params.appId = _appId
    }

    let obj = {}
    obj['method'] = method
    obj['url'] = sendUrl
    obj['data'] = method === 'POST' || method === 'PUT' ? params : null
    obj['params'] = method === 'GET' || method === 'DELETE' ? params : null
    obj['headers'] = {
      'Content-type': 'application/x-www-form-urlencoded',

    }

    // if (app_session) {

    //    //fix jr 转换

    //  let value = app_session.value;

    //  console.log('data的value',value);

    //  value = JSON.parse(value);
    // // //fix jr 转换结束

    //  console.log('打印这个value',value.session);

    //   obj['headers']['session'] =  value.session;//app_session.session //
    // }

    if (app_session) {

      //  let value = app_session.value;

    //  console.log('data的value',value);

    //  value = JSON.parse(value);
    // // //fix jr 转换结束

    //  console.log('打印这个value',value.session);

    //   obj['headers']['session'] =  value.session;//app_session.session //

    if(app_session.session){
      obj['headers']['session'] = app_session.session
      console.log('app_session.session',app_session.session)

    } else {
     let value = app_session.value;

     console.log('data的value',value);

     value = JSON.parse(value);
    // //fix jr 转换结束

     console.log('打印这个value',value.session);

      obj['headers']['session'] =  value.session;//app_session.session //
      obj['headers']['clientType'] = 'H5'
    }


    }

    obj['withCredentials'] = false
    obj['transformRequest'] = [function (data) {
      //post 請求不格式化
      // if (method == "POST") {
      //   console.log("data", data)
      //   return data;
      // }
      let ret = ''
      for (let it in data) {
        if (data[it] instanceof Array) {
          // 数组
          for (let item in data[it]) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it][item]) + '&'
          }
        } else {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
      }
      return ret
    }]

    axios(obj).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })

  })

}


function merge(url, obj) {

  //構造請求體
  let postD = [];
  for (let i in obj) {
    let d = {
      id: i
    }
    let item = obj[i];
    let u = item.url + "?"
    let pStr = '';
    for (let p in item.param) {
      let pVal = item.param[p];
      if (typeof (pVal) === "Object") {
        pStr += `&${p}=${JSON.stringify(pVal)}`
      } else {
        pStr += `&${p}=${pVal}`
      }
    }
    u += pStr;
    d.url = u;
    postD.push(d)

  }
  url += "?data=" + encodeURIComponent(JSON.stringify(postD)); //不知道為什麼，反正這樣可以



  return apiAxios("GET", url, {}).then(res => {

    //將結果裝入OBJ
    for (let idx in res) {
      let id = res[idx].id;
      obj[id].data = res[idx].result
    }
    return obj
  }).catch(e => {

    console.log(e);


    return e
  })



}

export default {
  setAppId,
  doAxios,
  blockAxios,
  allAxios,
  merge,
  setNative,
  apiAxios,
  doSessionAxios
}



// WEBPACK FOOTER //
// ./src/utils/request.js